<template>
    <v-container id="facturas-ivt">
      <v-row class="text-center">
        <v-col cols="12">
          <v-card class="alineacentro DatosMatriculado">
            <v-card-title class="DatosMatriculado">
              <v-row class="text-center">
                <v-col cols="12">
                  <v-card
                    class="alineacentro DatosMatriculado"
                    dark
                    color="success"
                  >
                    <strong>MOVIMIENTOS DE CUENTA CORRIENTE DE ALUMNOS</strong>
                  </v-card>
                </v-col>
              </v-row>
            </v-card-title>
            <v-card-text>
              <v-row dense>
                <v-col cols="12">
                  <v-spacer />
                </v-col>
              </v-row>
              <v-row class="text-center">
                <v-col cols="12" md="8" lg="8">
                  <selector-alumno
                    ref="selalumno"
                    class="alineaizquierda"
                    @selAlumno="asignaalumnoatrabajar"
                    :nivel=0
                  ></selector-alumno>
                </v-col>
                <v-col cols="12" md="4" lg="4">
                  <v-btn
                    class="ma-2"
                    dark
                    x-small
                    color="primary"
                    title="Listar"
                    @click="listar"
                    :disabled="!permisolectura || idalumnosel===null || idalumnosel===0"
                  >
                    <v-icon dark> mdi-magnify </v-icon>
                  </v-btn>
                  <v-btn
                    class="ma-2"
                    dark
                    x-small
                    color="primary"
                    title="Nuevo Movimiento"
                    @click="nueva"
                    :disabled="!permisoescritura || idalumnosel===null || idalumnosel===0"
                  >
                    <v-icon dark> mdi-new-box </v-icon>
                  </v-btn>
                </v-col>
              </v-row>
              <v-row v-show="idalumnosel!=null && idalumnosel!=0" class="text-center">
                <v-col cols="12">
                  <v-data-table
                    :headers="columnasmov"
                    :items="listamov"
                    :items-per-page="15"
                    :footer-props="{
                        'items-per-page-text': 'Filas por Página:',
                        'items-per-page-all-text': 'Todos',
                    }"
                    item-key="idmovimiento"
                    class="elevation-1"
                    dense
                    no-data-text="Sin Registros"
                    multi-sort
                  >
                    <template v-slot:item.actions="{ item }">
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn
                            small
                            icon
                            color="red"
                            @click="borrarmovmanual(item)"
                            v-bind="attrs"
                            v-on="on"
                            v-show="item.movmanual"
                            :disabled="item.monto!=item.saldo"
                          >
                            <v-icon>mdi-delete</v-icon>
                          </v-btn>
                        </template>
                        <span>Borrar Movimiento</span>
                      </v-tooltip>
                    </template>
                    <template v-slot:item.tipomov="{ item }">
                      <v-chip :color="getcolormov(item.tipomov)" dark>
                        <p class="textofilagrilla">{{ item.tipomov }}</p>
                      </v-chip>
                    </template>
                    <template  slot="body.append">
                        <tr>
                            <th class="title" colspan="6">Totales</th>
                            <th class="title">{{ sumField('monto') }}</th>
                            <th class="title red--text">{{ sumField('saldo') }}</th>
                            <th class="title" colspan="2"></th>
                        </tr>
                    </template>
                  </v-data-table>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
      <v-dialog v-model="dialogmensaje" persistent max-width="290">
        <v-card>
            <v-card-title class="headline">
            {{ mensajetitulo }}
            </v-card-title>
            <v-card-text>
            {{ mensajecuerpo }}
            </v-card-text>
            <v-card-actions>
            <v-spacer />
            <v-btn
                color="green darken-1"
                text
                @click="
                dialogmensaje = false;
                if (mensajehome === true) {
                    $router.push('Home');
                }
                "
            >
                Aceptar
            </v-btn>
            </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog v-model="loading" full-width>
        <v-container
            fluid
            class="full-height"
            style="background-color: rgba(255, 255, 255, 0.5)"
        >
            <v-row
            align="center"
            justify="center"
            style="height: 100vh"
            no-gutters
            dense
            >
            <v-col class="elementocentrado">
                <v-progress-circular indeterminate color="primary" />
            </v-col>
            </v-row>
        </v-container>
      </v-dialog>
      <v-dialog v-model="dialognuevo" persistent max-width="700">
        <v-card>
          <v-card-title class="headline">
            Agregando Movimiento Manual...
          </v-card-title>
          <v-card-actions>
            <v-row>
              <v-col cols="12" class="alineaderecha">
                <v-btn color="green darken-1" text @click="grabarmov">
                    Grabar
                </v-btn>
                <v-btn color="red darken-1" text @click="dialognuevo = false">
                    Cancelar
                </v-btn>
              </v-col>
            </v-row>
          </v-card-actions>
          <v-card-text>
            <br />
            <br />
            <v-row>
              <!--<v-col cols="12" md="3" lg="3">
                <v-select
                  v-model="editedmov.idtipomov"
                  :items="listatiposmov"
                  label="Tipo Mov."
                  item-text="nombre"
                  item-value="idtipomov"
                  height="20px"
                />
              </v-col>-->
              <v-col cols="12" md="4" lg="4">
                <v-menu
                  v-model="menufechamov"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="fechalocalmov"
                      label="Fecha"
                      prepend-icon="mdi-calendar"
                      v-bind="attrs"
                      v-on="on"
                      height="20px"
                      readonly
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="editedmov.fecha"
                    @input="menufechamov = false"
                  ></v-date-picker>
                </v-menu>
              </v-col>
              <v-col cols="12" md="4" lg="4">
                <v-menu
                  ref="menuhoramov"
                  v-model="menuhoramov"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  :return-value.sync="editedmov.hora"
                  transition="scale-transition"
                  offset-y
                  max-width="290px"
                  min-width="290px"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                        v-model="editedmov.hora"
                        label="Hora"
                        prepend-icon="mdi-clock-time-four-outline"
                        readonly
                        v-bind="attrs"
                        v-on="on"
                        height="20px"
                    ></v-text-field>
                  </template>
                  <v-time-picker
                    v-if="menuhoramov"
                    v-model="editedmov.hora"
                    full-width
                    @click:minute="$refs.menuhoramov.save(editedmov.hora)"
                  ></v-time-picker>
                </v-menu>
              </v-col>
              <v-col cols="12" md="4" lg="4">
                <v-menu
                  v-model="menuvencmov"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="fechalocalvenc"
                      label="Vencimiento"
                      prepend-icon="mdi-calendar"
                      v-bind="attrs"
                      v-on="on"
                      height="20px"
                      readonly
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="editedmov.vencimiento"
                    @input="menuvencmov = false"
                  ></v-date-picker>
                </v-menu>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" md="9" lg="9">
                <v-text-field
                  v-model="editedmov.descripcion"
                  label="Descripción"
                  height="20px"
                />
              </v-col>
              <v-col cols="12" md="3" lg="3">
                <v-text-field
                  v-model="editedmov.monto"
                  label="Monto"
                  height="20px"
                  type="number"
                />
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12">
                <v-text-field
                  v-model="editedmov.observacion"
                  label="Observación"
                  height="20px"
                />
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-dialog>
      <ConfirmDlg ref="confirm" />
    </v-container>
</template>
<script>
import axios from "@/axios";
import ConfirmDlg from "../Confirm.vue";
import SelectorAlumno from "../../components/SelectorAlumno.vue";
export default {
  name: "Facturas",
  components: {
    ConfirmDlg: ConfirmDlg,
    SelectorAlumno: SelectorAlumno
  },
  data() {
    return {
      loading: false,
      usuario: "",
      usuariosede: 0,
      permisolectura: false,
      permisoescritura: false,
      nromodulo: 17,
      roles: [],
      dialogmensaje: false,
      mensajetitulo: "",
      mensajecuerpo: "",
      mensajehome: false,
      columnasmov: [
        {
            text: 'Op.',
            value: 'actions',
            sortable: false,
            width: 30
        },
        {
          text: "ID Mov",
          align: "center",
          sortable: true,
          value: "idmovimiento",
          width: 90
        },
        {
          text: "Fecha",
          align: "center",
          sortable: true,
          value: "fechahoradmy",
          width: 130
        },
        {
          text: "Fecha Registro",
          align: "center",
          sortable: true,
          value: "fechahoraregistrodmy",
          width: 130
        },
        {
          text: "Tipo",
          align: "center",
          sortable: true,
          value: "tipomov",
          width: 110
        },
        {
          text: "Descripción",
          align: "center",
          sortable: true,
          value: "descripcion",
          width: 200
        },
        {
          text: "Monto",
          align: "center",
          sortable: true,
          value: "monto",
          width: 90
        },
        {
          text: "Saldo",
          align: "center",
          sortable: true,
          value: "saldo",
          width: 90
        },
        {
          text: "Vencimiento",
          align: "center",
          sortable: true,
          value: "vencimientodmy",
          width: 130
        },
        {
          text: "Estado",
          align: "center",
          sortable: true,
          value: "estado",
          width: 90
        },
      ],
      listamov: [],
      idalumnosel: 0,
      dialognuevo: false,
      editedmov: {
        idmovimiento: 0,
        idpersona: 0,
        fecha: '',
        hora: '',
        descripcion: '',
        idtipomov: 0,
        vencimiento: '',
        monto: 0,
        observacion: '',
        usuario: ''
      },
      listatiposmov: [
        { idtipomov: 1, nombre: 'Debe' },
        { idtipomov: 2, nombre: 'Haber' }
      ],
      menufechamov: false,
      menuhoramov: false,
      menuvencmov: false
    };
  },
  mounted() {
    this.loading = true;
    this.usuario = localStorage.getItem("user");
    this.usuariosede = localStorage.getItem("idsede");
    var permisos = JSON.parse(localStorage.getItem("permisos"));
    //var roles = localStorage.getItem("rolesusuario");
    var rolesuser = localStorage.getItem("rolesuserid").split(',');
    rolesuser.forEach((elemento) => {
        this.roles.push(parseInt(elemento));
    });
    var existeper = permisos.filter((p) => p.nromodulo === this.nromodulo && (this.roles.includes(p.idrol) || p.usuario === this.usuario) && p.idaccion === 1);
    if (existeper.length === 0) {
      this.loading = false;
      this.mostrarmensaje("Error","No tiene permisos para acceder a este módulo.",true);
    } else {
      this.permisolectura = permisos.filter((p) => p.nromodulo === this.nromodulo && (this.roles.includes(p.idrol) || p.usuario === this.usuario) && p.idaccion === 2).length > 0 ? true : false;
      this.permisoescritura = permisos.filter((p) => p.nromodulo === this.nromodulo && (this.roles.includes(p.idrol) || p.usuario === this.usuario) && p.idaccion=== 3).length > 0 ? true : false;
      this.loading = false;
    }
  },
  methods: {
    mostrarmensaje(titulo, cuerpo, home) {
      this.mensajetitulo = titulo;
      this.mensajecuerpo = cuerpo;
      this.mensajehome = home != null ? home : false;
      this.dialogmensaje = true;
    },
    fechaFormatoYMD(date) {
      return (date.getFullYear() + "-" + ((date.getMonth() + 1).toString().length != 2 ? "0" + (date.getMonth() + 1) : date.getMonth() + 1) + "-" + (date.getDate().toString().length != 2 ? "0" + date.getDate() : date.getDate()));
    },
    horaFormatoymd(date) {
      return ((date.getHours().toString().length != 2 ? "0" + date.getHours().toString() : date.getHours().toString()) + ":"
      + (date.getMinutes().toString().length != 2 ? "0" + date.getMinutes().toString() : date.getMinutes().toString())
      //+ ":"+ (date.getSeconds().toString().length != 2 ? "0" + date.getSeconds().toString() : date.getSeconds().toString())
      );
    },
    listar () {
      this.loading=true;
      var fecdesde = ' ';
      var fechasta = ' ';
      var idalumno = this.idalumnosel != '' && this.idalumnosel != null ? this.idalumnosel : 0;
      var concepto =  ' ';
      axios.get("contable/ListaMovimientosCCAlumno/" + fecdesde +"/"+ fechasta +"/ /"+ concepto +"/0/0/"+ idalumno).then((result) => {
        if(result.data.resultado===0){
          this.listamov = result.data.datos;
          this.loading=false;
        }else{
          this.loading = false;
          this.mostrarmensaje("Error", result.data.resultadomensaje, false);
        }
      }).catch((error) => {
        this.loading = false;
        this.mostrarmensaje("Error", error, false);
      });
    },
    nueva () {
      this.editedmov= {
        idmovimiento: 0,
        idpersona: this.idalumnosel,
        fecha: this.fechaFormatoYMD(new Date()),
        hora: this.horaFormatoymd(new Date()),
        descripcion: '',
        idtipomov: 1,
        vencimiento: '',
        monto: 0.00,
        observacion: '',
        usuario: this.usuario
      };
      this.dialognuevo= true;
    },
    grabarmov () {
      var valido='';
      if(this.editedmov.fecha===null && this.editedmov.fecha===''){
        valido= 'Debe ingresar fecha del movimiento';
      }
      if(this.editedmov.hora===null && this.editedmov.hora===''){
        valido= 'Debe ingresar hora del movimiento';
      }
      if(this.editedmov.descripcion===null && this.editedmov.descripcion===''){
        valido= 'Debe ingresar descripción del movimiento';
      }
      if(this.editedmov.monto===null && parseFloat(this.editedmov.monto)===0){
        valido= 'Debe ingresar monto válido del movimiento';
      }

      if(valido.length===0) {
        this.loading= true;
        this.editedmov.monto= parseFloat(this.editedmov.monto);
        const movimiento = JSON.stringify(this.editedmov);
        axios.post("contable/PostMovimientoCCManual", movimiento, { headers: {"Content-Type": "application/json", }}).then((result) => {
          if(result.data.resultado===0) {
            this.dialognuevo= false;
            this.listar();
          }else{
            this.loading = false;
            this.mostrarmensaje("Error", result.data.resultadomensaje, false);
          }
        }).catch((error) => {
          this.loading = false;
          this.mostrarmensaje("Error", error, false);
        });
      }else{
        this.mostrarmensaje('Error', valido, false);
      }
    },
    asignaalumnoatrabajar (value) {
      if(value!=null){
        this.idalumnosel= value.idalumno;
        this.Listar();
      }else{
        this.idalumnosel= 0;
      }
    },
    async borrarmovmanual (item) {
      if (await this.$refs.confirm.open('Borra Movimiento', '¿Esta seguro de querer borrar el movimiento manual?')) {
        this.loading= true;
        const movimiento = JSON.stringify({idmovimiento: item.idmovimiento, usuario: this.usuario});
        axios.post("contable/PostBorrarMovimientoCCManual", movimiento, { headers: {"Content-Type": "application/json", }}).then((result) => {
          if (result.data.resultado === 0) {
            this.listar();
          }else{
            this.loading = false;
            this.MostrarMensaje("Error", result.data.resultadomensaje, false);
          }
        }).catch((error) => {
          this.loading = false;
          this.MostrarMensaje("Error", error, false);
        });
      }
    },
    getcolormov(estado){
      if (estado === 'Debe') {return "red";}
      else if (estado === 'Haber') {return "green";}
    },
    sumField(key) {
        // sum data in give key (property)
        return this.listamov.reduce((a, b) => a + (b[key] || 0), 0)
    }
},
  computed: {
    fechalocalmov: function () {
      if (this.editedmov.fecha != null && this.editedmov.fecha != "") {
        var fecha = new Date(this.editedmov.fecha);
        fecha.setDate(fecha.getDate() + 1);
        return fecha.toLocaleDateString("es-AR");
      } else {
        return "";
      }
    },
    fechalocalvenc: function () {
      if (this.editedmov.vencimiento != null && this.editedmov.vencimiento != "") {
        var fecha = new Date(this.editedmov.vencimiento);
        fecha.setDate(fecha.getDate() + 1);
        return fecha.toLocaleDateString("es-AR");
      } else {
        return "";
      }
    },
},
};
</script>
<style>
.v-data-table > .v-data-table__wrapper > table > tbody > tr > td, .v-data-table > .v-data-table__wrapper > table > thead > tr > td, .v-data-table > .v-data-table__wrapper > table > tfoot > tr > td {
    font-size: 0.680rem !important;
    height: 25px !important;
}

.textofilagrilla {
  font-size: 0.680rem !important;
  height: 5px !important;
}

.filadeuda td {
    color: red;
}
.textoColorBlanco {
    color: white;
}

.filadescuento td {
    color: green;
}

.filatotal td {
    color: blue;
}

.titulocardchico {
  padding: 8px !important;
}
.textocentrado {
  text-align: center;
}
.elementocentrado {
  display: flex;
  justify-content: center;
  align-items: center;
}
.col-xl,
.col-xl-auto,
.col-xl-12,
.col-xl-11,
.col-xl-10,
.col-xl-9,
.col-xl-8,
.col-xl-7,
.col-xl-6,
.col-xl-5,
.col-xl-4,
.col-xl-3,
.col-xl-2,
.col-xl-1,
.col-lg,
.col-lg-auto,
.col-lg-12,
.col-lg-11,
.col-lg-10,
.col-lg-9,
.col-lg-8,
.col-lg-7,
.col-lg-6,
.col-lg-5,
.col-lg-4,
.col-lg-3,
.col-lg-2,
.col-lg-1,
.col-md,
.col-md-auto,
.col-md-12,
.col-md-11,
.col-md-10,
.col-md-9,
.col-md-8,
.col-md-7,
.col-md-6,
.col-md-5,
.col-md-4,
.col-md-3,
.col-md-2,
.col-md-1,
.col-sm,
.col-sm-auto,
.col-sm-12,
.col-sm-11,
.col-sm-10,
.col-sm-9,
.col-sm-8,
.col-sm-7,
.col-sm-6,
.col-sm-5,
.col-sm-4,
.col-sm-3,
.col-sm-2,
.col-sm-1,
.col,
.col-auto,
.col-12,
.col-11,
.col-10,
.col-9,
.col-8,
.col-7,
.col-6,
.col-5,
.col-4,
.col-3,
.col-2,
.col-1 {
  padding: 2px !important;
}
@media only screen and (min-width: 960px) {
  .altojusto {
    height: 45px !important;
  }
}
.alineaizquierda {
  text-align: left;
}
.alineacentro {
  text-align: center;
}
.alineaderecha {
  text-align: right;
}
.ocupa30 {
  width: 30%;
}
.ocupa45 {
  width: 45%;
}
.ocupa50 {
  width: 50%;
}
.ocupa60 {
  width: 60%;
}
.ocupa75 {
  width: 75%;
}
.ocupa80 {
  width: 80%;
}
.ocupa95 {
  width: 95%;
}
.centradovertical {
  vertical-align: middle;
  align-items: center;
}
.abajovertical {
  vertical-align: bottom;
}
.TituloGrilla {
  font-family: Tahoma;
  font-size: medium;
  font-weight: bold;
  background-color: darkgray;
}
.TituloGrilla2 {
  font-family: Tahoma;
  font-size: medium;
  font-weight: bold;
  color: white;
  background-color: dimgray;
}
.textoNegritaRojo {
  color: red !important;
  font-weight: bold !important;
}
.textoNegrita {
  font-weight: bold !important;
}
.textoNegritaTitulo {
  font-weight: bold !important;
  font-size: medium;
}
.textoNegritaMontos {
  font-weight: bold !important;
  font-size: 11pt;
  padding-right: 10px;
}
.margenizquierdo{
    padding-left: 10px;
}
.textoNegritaVerde {
  color: rgb(83, 248, 125) !important;
  font-weight: bold !important;
}
.container {
  max-width: unset !important;
}
</style>

